import { useMutation } from "@shared/lib/hooks";
import { AgencyService } from "../services/agency.service";
import { ToastService } from "@shared/lib/services";
import {
  AGENCY_EMPLOYEE_LIST_QUERY_KEY,
  AGENCY_LIST_QUERY_KEY,
} from "../constants/querykeys";
import { BackednResponse } from "@shared/lib/types";
import { Agency, AgencyUser } from "@shared/lib/types/agency";

export function useEditAgencyEmployeePermissions() {
  const {
    mutate: editAgencyUserPermissions,
    isLoading: isEditing,
    isSuccess: isEdited,
    isError: isEditFailed,
  } = useMutation<
    { agencyId: string; agencyUserId: string; permissions: string[] },
    BackednResponse<Agency> | void
  >({
    mutationFn: async ({ agencyId, agencyUserId, permissions }) => {
      return (await AgencyService.editAgencyUserPermissions(
        agencyId,
        agencyUserId,
        permissions
      )) as BackednResponse<Agency>;
    },
    options: {
      queryKey: AGENCY_EMPLOYEE_LIST_QUERY_KEY,
      skipInvalidation: false,
    },
    onSuccess: (c, _, { agencyId }) => {
      c.invalidateQueries({
        queryKey: [...AGENCY_LIST_QUERY_KEY, agencyId],
      });
    },
  });

  return {
    editAgencyUserPermissions,
    isEditing,
    isEdited,
    isEditFailed,
  };
}
